import React, { ReactNode } from "react";
import { ModalsKeys } from "global";
import { useSelector } from "react-redux";
import { useParams, useHistory } from "react-router-dom";
import { PageContainer } from "components/shared/Page/PageContainer";
import { EquipmentWorkFlow, CreateUpdateEquipmentDialog } from "modules/equipment";

const modals: Partial<Record<ModalsKeys, ReactNode>> = {
  [ModalsKeys.CreateUpdateEquipmentDialog]: <CreateUpdateEquipmentDialog />,
};

export const EquipmentPage = () => {
  const history = useHistory();
  const { VOId, dynamicVOId, equipmentId } = useParams<{
    VOId: string;
    dynamicVOId: string;
    equipmentId: string | undefined;
  }>();

  const handleGoToVO = () => {
    history.push(`/vo/${VOId}`);
  };

  const accountId = useSelector((state: any) => state.account.id);

  return (
    <PageContainer modals={modals}>
      <EquipmentWorkFlow
        VOId={VOId}
        accountId={accountId}
        equipmentId={equipmentId}
        dynamicVOId={dynamicVOId}
        onRedirect={handleGoToVO}
      />
    </PageContainer>
  );
};
